import { render, staticRenderFns } from "./Instruction.vue?vue&type=template&id=01dcd7a7&scoped=true&"
import script from "./Instruction.vue?vue&type=script&lang=js&"
export * from "./Instruction.vue?vue&type=script&lang=js&"
import style0 from "./Instruction.vue?vue&type=style&index=0&id=01dcd7a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dcd7a7",
  null
  
)

export default component.exports